import { render, staticRenderFns } from "./CampoUnico.vue?vue&type=template&id=411b394e&"
import script from "./CampoUnico.vue?vue&type=script&lang=js&"
export * from "./CampoUnico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('411b394e', component.options)
    } else {
      api.reload('411b394e', component.options)
    }
    module.hot.accept("./CampoUnico.vue?vue&type=template&id=411b394e&", function () {
      api.rerender('411b394e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Form/CampoUnico.vue"
export default component.exports